const getActivityById = (activityId, activities) => {
    const found = activities.find((a) => a.id === activityId);
    return found ?? unspecifiedActivity();
};
const unspecifiedActivity = () => {
    return {
        id: '',
        name: 'Uspesifisert',
        description: 'Det er ikke spesifisert hva slags aktivitet timen er myntet på.',
        color: '#ffffff',
        spaceTime: '',
        firstTicketOption: false,
        showOnSlotPicker: true
    };
};
const toActivity = (raw) => {
    const activity = unspecifiedActivity();
    if (!raw)
        return activity;
    if (raw.id)
        activity.id = raw.id;
    if (raw.name)
        activity.name = raw.name;
    if (raw.description)
        activity.description = raw.description;
    if (raw.color)
        activity.color = raw.color;
    if (raw.spaceTime)
        activity.spaceTime = raw.spaceTime;
    activity.firstTicketOption = !!raw.firstTicketOption;
    activity.showOnSlotPicker = raw.showOnSlotPicker ?? true;
    return activity;
};
const toActivities = (raw) => {
    if (!Array.isArray(raw))
        return [unspecifiedActivity()];
    const newActivities = raw.map((a) => toActivity(a));
    if (newActivities.length === 0)
        return [unspecifiedActivity()];
    return newActivities;
};
export { toActivities, unspecifiedActivity, getActivityById };
//# sourceMappingURL=activity.js.map